const AU_HOST = 'www.alderfinejewellery.com.au';
const US_HOST = 'www.alderfinejewellery.com';

const STORE_BY_HOST = {
  'www.alderfinejewellery.com.au': 'au',
  'alderfinejewellery.com.au': 'au',
  'www.alderfinejewellery.com': 'us',
  'alderfinejewellery.com': 'us'
};

const HOST_BY_STORE = {
  au: AU_HOST,
  us: US_HOST
};

const STORE_LABEL = {
  au: 'AU',
  us: 'US'
};

const DEFAULT_COUNTRY_TO_STORE = {
  AU: 'au',
  NZ: 'au',
  SG: 'au',
  MY: 'au',
  TH: 'au',
  ID: 'au',
  VN: 'au',
  PH: 'au',
  HK: 'au',
  JP: 'au',
  KR: 'au',
  IN: 'au',
  US: 'us',
  CA: 'us',
  AE: 'us',
  GB: 'us',
  IE: 'us',
  FR: 'us',
  DE: 'us',
  IT: 'us',
  ES: 'us',
  NL: 'us',
  BE: 'us',
  CH: 'us',
  AT: 'us',
  SE: 'us',
  NO: 'us',
  DK: 'us',
  FI: 'us',
  PT: 'us',
  PL: 'us',
  CZ: 'us',
  SK: 'us',
  HU: 'us',
  RO: 'us',
  BG: 'us',
  GR: 'us',
  EE: 'us',
  LV: 'us',
  LT: 'us',
  HR: 'us',
  SI: 'us',
  LU: 'us',
  MT: 'us',
  CY: 'us'
};

const COUNTRY_ROUTE_ALIASES = {
  USA: ['US'],
  US: ['US'],
  CANADA: ['CA'],
  CA: ['CA'],
  UAE: ['AE'],
  AE: ['AE'],
  EUROPE: ['GB', 'IE', 'FR', 'DE', 'IT', 'ES', 'NL', 'BE', 'CH', 'AT', 'SE', 'NO', 'DK', 'FI', 'PT', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR', 'EE', 'LV', 'LT', 'HR', 'SI', 'LU', 'MT', 'CY'],
  EU: ['GB', 'IE', 'FR', 'DE', 'IT', 'ES', 'NL', 'BE', 'CH', 'AT', 'SE', 'NO', 'DK', 'FI', 'PT', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR', 'EE', 'LV', 'LT', 'HR', 'SI', 'LU', 'MT', 'CY'],
  ASIA: ['NZ', 'SG', 'MY', 'TH', 'ID', 'VN', 'PH', 'HK', 'JP', 'KR', 'IN', 'CN', 'TW', 'MO'],
  APAC: ['NZ', 'SG', 'MY', 'TH', 'ID', 'VN', 'PH', 'HK', 'JP', 'KR', 'IN', 'CN', 'TW', 'MO']
};

const DEFAULT_HIGH_CONFIDENCE_COUNTRIES = ['AU', 'US'];

const COOKIE_NAME = 'afj_store_preference';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 45;
const EXPERIMENT_COOKIE_NAME = 'afj_geo_experiment_variant';
const EXPERIMENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
const SWITCH_PARAM = 'geo_switch';
const AUTO_REDIRECT_SESSION_KEY = 'afj_geo_auto_redirect_store';
const PROMPT_DISMISSED_SESSION_KEY_PREFIX = 'afj_geo_prompt_dismissed';
const DEFAULT_EXPERIMENT_VARIANTS = ['control', 'prompt_first', 'aggressive_auto'];

const EXCLUDED_PATH_PREFIXES = ['/checkout', '/account', '/apps'];
const EXCLUDED_EXACT_PATHS = ['/cart'];
const BLOCKING_THEME_POPUP_SELECTORS = ['#popup', '#slide-up', '#verification-popup'];
const MAX_MODAL_WAIT_ATTEMPTS = 20;
const MODAL_WAIT_INTERVAL_MS = 500;
const COUNTRY_DETECTION_TIMEOUT_MS = 1200;
const BROWSING_CONTEXT_SUGGESTIONS_PATH = '/browsing_context_suggestions.json?country[enabled]=true';
const QA_DEBUG_TOKEN = 'afj_geo_debug_v1';

const currentHost = window.location.hostname.toLowerCase();
const geoConfig = window.afjGeoRedirectConfig || {};
const isThemeEditor =
  Boolean(geoConfig.isThemeEditor) || Boolean(window.Shopify && window.Shopify.designMode);
const isLocalHost =
  currentHost === '127.0.0.1' ||
  currentHost === 'localhost' ||
  currentHost.endsWith('.localhost');
const isPreviewHost = currentHost.includes('shopifypreview.com');
const isQaHost = isLocalHost || isPreviewHost;
const urlParams = new URLSearchParams(window.location.search);
const qaDebugEnabled = String(urlParams.get('geo_debug') || '').trim() === QA_DEBUG_TOKEN;
const allowQaOverrides = isQaHost || qaDebugEnabled;
const localStoreOverride = urlParams.get('geo_store');
const forceLocalPrompt =
  allowQaOverrides &&
  ['1', 'true', 'yes', 'on'].includes(
    String(urlParams.get('geo_force_prompt') || '').trim().toLowerCase()
  );
const autoRedirectEnabled = resolveAutoRedirectEnabled();
const countryToStoreMap = resolveCountryToStoreMap();
const highConfidenceCountries = resolveHighConfidenceCountries();
const phase4Experiment = resolvePhase4Experiment();
const popupSettings = resolvePopupSettings();
let detectedCountryCodePromise;

const currentStore =
  STORE_BY_HOST[currentHost] ||
  (allowQaOverrides && (localStoreOverride === 'au' || localStoreOverride === 'us')
    ? localStoreOverride
    : allowQaOverrides
      ? resolveLocalHostCurrentStore()
      : undefined);

initGeoStorePrompt().catch(() => {});

async function initGeoStorePrompt() {
  const countryCode = await getCountryCode();

  if (isThemeEditor) {
    if (!popupSettings.enabled) {
      return;
    }

    const previewCurrentStore = currentStore || 'us';
    const previewSuggestedStore = previewCurrentStore === 'au' ? 'us' : 'au';

    renderPrompt({
      currentStore: previewCurrentStore,
      suggestedStore: previewSuggestedStore,
      countryCode,
      isPreviewMode: true
    });
    return;
  }

  if (!currentStore) {
    // Only run the prompt on the AU and US storefront domains.
    return;
  }

  if (isExcludedPath(window.location.pathname)) {
    return;
  }

  const arrivedFromSwitch = urlParams.has(SWITCH_PARAM);
  stripSwitchParamFromUrl();

  const cookiePreference = getCookie(COOKIE_NAME);
  if (
    shouldRespectPreferenceCookie() &&
    (cookiePreference === 'au' || cookiePreference === 'us')
  ) {
    // Respect prior explicit choice on this domain.
    return;
  }

  const mappedStore = countryToStoreMap[countryCode];
  const localFallbackStore = currentStore === 'au' ? 'us' : 'au';
  const suggestedStore =
    (mappedStore && mappedStore !== currentStore
      ? mappedStore
      : forceLocalPrompt
        ? localFallbackStore
        : mappedStore) || (isLocalHost ? localFallbackStore : undefined);

  if (!suggestedStore || suggestedStore === currentStore) {
    trackGeoEvent('no_action', {
      reason: 'same_or_unknown_target',
      currentStore,
      suggestedStore,
      countryCode
    });
    return;
  }

  const autoRedirectDecision = shouldAutoRedirect({
    suggestedStore,
    arrivedFromSwitch,
    countryCode
  });

  if (autoRedirectDecision.allowed) {
    markAutoRedirectedStore(suggestedStore);
    trackGeoEvent('auto_redirect', {
      fromStore: currentStore,
      toStore: suggestedStore,
      countryCode
    });
    window.location.replace(buildTargetUrl(HOST_BY_STORE[suggestedStore]));
    return;
  }

  trackGeoEvent('auto_redirect_skipped', {
    fromStore: currentStore,
    toStore: suggestedStore,
    countryCode,
    reason: autoRedirectDecision.reason
  });

  if (!popupSettings.enabled) {
    trackGeoEvent('prompt_skipped', {
      fromStore: currentStore,
      toStore: suggestedStore,
      countryCode,
      reason: 'popup_disabled'
    });
    return;
  }

  if (hasDismissedPromptThisSession(currentStore, suggestedStore)) {
    trackGeoEvent('prompt_skipped', {
      fromStore: currentStore,
      toStore: suggestedStore,
      countryCode,
      reason: 'session_prompt_dismissed'
    });
    return;
  }

  renderPromptWhenNoBlockingThemePopup(
    {
      currentStore,
      suggestedStore,
      countryCode
    },
    0
  );
}

function renderPromptWhenNoBlockingThemePopup(promptArgs, attemptCount = 0) {
  if (!hasBlockingThemePopup()) {
    renderPrompt(promptArgs);
    return;
  }

  if (attemptCount >= MAX_MODAL_WAIT_ATTEMPTS) {
    trackGeoEvent('prompt_skipped', {
      fromStore: promptArgs.currentStore,
      toStore: promptArgs.suggestedStore,
      countryCode: promptArgs.countryCode,
      reason: 'blocked_by_existing_popup'
    });
    return;
  }

  setTimeout(() => {
    renderPromptWhenNoBlockingThemePopup(promptArgs, attemptCount + 1);
  }, MODAL_WAIT_INTERVAL_MS);
}

function hasBlockingThemePopup() {
  if (allowQaOverrides) {
    return false;
  }

  const hasKnownBlockingPopup = BLOCKING_THEME_POPUP_SELECTORS.some(selector => {
    const node = document.querySelector(selector);

    if (!node || node.classList.contains('afj-geo-prompt')) {
      return false;
    }

    return isElementVisible(node);
  });

  if (hasKnownBlockingPopup) {
    return true;
  }

  const dialogs = Array.from(document.querySelectorAll('[role="dialog"]'));

  return dialogs.some(dialog => {
    if (dialog.classList.contains('afj-geo-prompt') || dialog.closest('.afj-geo-prompt')) {
      return false;
    }

    return isElementVisible(dialog);
  });
}

function isElementVisible(node) {
  const computedStyle = window.getComputedStyle(node);

  if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
    return false;
  }

  const opacity = Number.parseFloat(computedStyle.opacity || '1');
  if (opacity === 0) {
    return false;
  }

  const rect = node.getBoundingClientRect();
  if (rect.width > 0 && rect.height > 0) {
    return true;
  }

  // Check for zero-height wrappers with visible fixed children
  const children = node.children;
  const childCount = children.length;
  for (let i = 0; i < childCount; i += 1) {
    const child = children[i];
    const childStyle = window.getComputedStyle(child);

    if (childStyle.display === 'none' || childStyle.visibility === 'hidden' || Number.parseFloat(childStyle.opacity || '1') === 0) {
      continue;
    }

    const childRect = child.getBoundingClientRect();
    if (childRect.width > 0 && childRect.height > 0) {
      return true;
    }
  }

  return false;
}

function shouldRespectPreferenceCookie() {
  if (isThemeEditor) {
    return false;
  }

  // In "ask user to choose" mode, always allow the prompt to render.
  if (!autoRedirectEnabled) {
    return false;
  }

  // Keep localhost deterministic for QA without requiring manual cookie clearing.
  if (isLocalHost) {
    return false;
  }

  return true;
}

function resolvePhase4Experiment() {
  const enabled = resolvePhase4ExperimentEnabled();
  const forcedVariant = resolveForcedExperimentVariant();

  if (!enabled) {
    return {
      enabled: false,
      variant: 'control'
    };
  }

  if (forcedVariant) {
    return {
      enabled: true,
      variant: forcedVariant
    };
  }

  const existingVariant = getCookie(EXPERIMENT_COOKIE_NAME);
  if (DEFAULT_EXPERIMENT_VARIANTS.includes(existingVariant)) {
    return {
      enabled: true,
      variant: existingVariant
    };
  }

  const assignedVariant = pickRandomVariant(DEFAULT_EXPERIMENT_VARIANTS);
  setCookie(EXPERIMENT_COOKIE_NAME, assignedVariant, EXPERIMENT_COOKIE_MAX_AGE_SECONDS);

  return {
    enabled: true,
    variant: assignedVariant
  };
}

function resolvePhase4ExperimentEnabled() {
  const queryValue = urlParams.get('geo_exp_on');

  if (typeof queryValue === 'string' && queryValue.trim()) {
    const normalized = queryValue.trim().toLowerCase();

    if (['0', 'false', 'off', 'no'].includes(normalized)) {
      return false;
    }

    if (['1', 'true', 'on', 'yes'].includes(normalized)) {
      return true;
    }
  }

  if (typeof geoConfig.enablePhase4Experiment === 'boolean') {
    return geoConfig.enablePhase4Experiment;
  }

  // Phase 4 rollout mode: enabled by default.
  return true;
}

function resolveForcedExperimentVariant() {
  const queryVariant = urlParams.get('geo_exp');

  if (typeof queryVariant === 'string' && queryVariant.trim()) {
    const normalized = queryVariant.trim().toLowerCase();

    if (DEFAULT_EXPERIMENT_VARIANTS.includes(normalized)) {
      return normalized;
    }
  }

  if (typeof geoConfig.experimentVariant === 'string') {
    const normalized = geoConfig.experimentVariant.trim().toLowerCase();

    if (DEFAULT_EXPERIMENT_VARIANTS.includes(normalized)) {
      return normalized;
    }
  }

  return '';
}

function pickRandomVariant(variants) {
  const randomIndex = Math.floor(Math.random() * variants.length);
  return variants[randomIndex];
}

function resolveCountryToStoreMap() {
  const mergedMap = {
    ...DEFAULT_COUNTRY_TO_STORE
  };

  const legacyConfiguredMap = geoConfig.countryMap;
  if (legacyConfiguredMap && typeof legacyConfiguredMap === 'object') {
    Object.keys(legacyConfiguredMap).forEach(countryCode => {
      const normalizedCountryCode = countryCode.trim().toUpperCase();
      const configuredStore = String(legacyConfiguredMap[countryCode] || '').trim().toLowerCase();

      if (configuredStore === 'au' || configuredStore === 'us') {
        mergedMap[normalizedCountryCode] = configuredStore;
      }
    });
  }

  const configuredRouting =
    (geoConfig.popup && geoConfig.popup.countryRouting) || geoConfig.countryRouting;
  if (configuredRouting && typeof configuredRouting === 'object') {
    getConfiguredCountryCodes(configuredRouting.auCountries || configuredRouting.au).forEach(
      countryCode => {
        mergedMap[countryCode] = 'au';
      }
    );

    getConfiguredCountryCodes(configuredRouting.usCountries || configuredRouting.us).forEach(
      countryCode => {
        mergedMap[countryCode] = 'us';
      }
    );
  }

  return mergedMap;
}

function getConfiguredCountryCodes(value) {
  if (Array.isArray(value)) {
    return value
      .flatMap(entry => getConfiguredCountryCodes(entry))
      .filter(Boolean);
  }

  if (typeof value !== 'string') {
    return [];
  }

  const tokens = value.split(/[\n,;]+/);
  const countryCodes = [];

  tokens.forEach(token => {
    const normalizedToken = token.trim().toUpperCase();

    if (!normalizedToken) {
      return;
    }

    const aliasedCodes = COUNTRY_ROUTE_ALIASES[normalizedToken];
    if (Array.isArray(aliasedCodes)) {
      aliasedCodes.forEach(countryCode => {
        countryCodes.push(countryCode);
      });
      return;
    }

    if (/^[A-Z]{2}$/.test(normalizedToken)) {
      countryCodes.push(normalizedToken);
    }
  });

  return Array.from(new Set(countryCodes));
}

function resolveHighConfidenceCountries() {
  const queryValue = urlParams.get('geo_high_conf');
  const configuredCountries = [];

  if (typeof queryValue === 'string' && queryValue.trim()) {
    configuredCountries.push(...getConfiguredCountryCodes(queryValue));
  }

  if (Array.isArray(geoConfig.highConfidenceCountries)) {
    configuredCountries.push(...getConfiguredCountryCodes(geoConfig.highConfidenceCountries));
  }

  return Array.from(
    new Set([...DEFAULT_HIGH_CONFIDENCE_COUNTRIES, ...Object.keys(countryToStoreMap), ...configuredCountries])
  );
}

function resolveAutoRedirectEnabled() {
  const autoParam = urlParams.get('geo_auto');

  if (typeof autoParam === 'string' && autoParam.trim()) {
    const normalized = autoParam.trim().toLowerCase();

    if (['0', 'false', 'off', 'no'].includes(normalized)) {
      return false;
    }

    if (['1', 'true', 'on', 'yes'].includes(normalized)) {
      return true;
    }
  }

  if (typeof geoConfig.enableAutoRedirect === 'boolean') {
    return geoConfig.enableAutoRedirect;
  }

  // Phase 2 default: enabled unless explicitly switched off.
  return true;
}

function shouldAutoRedirect({ suggestedStore, arrivedFromSwitch, countryCode }) {
  if (isThemeEditor) {
    return {
      allowed: false,
      reason: 'theme_editor_preview'
    };
  }

  if (popupSettings.enabled && popupSettings.autoRedirectAfterCountdown) {
    return {
      allowed: false,
      reason: 'countdown_popup_enabled'
    };
  }

  if (!autoRedirectEnabled) {
    return {
      allowed: false,
      reason: 'auto_redirect_disabled'
    };
  }

  if (!suggestedStore || !HOST_BY_STORE[suggestedStore]) {
    return {
      allowed: false,
      reason: 'missing_target_store'
    };
  }

  if (arrivedFromSwitch) {
    return {
      allowed: false,
      reason: 'arrived_from_manual_switch'
    };
  }

  if (isBotTraffic()) {
    return {
      allowed: false,
      reason: 'bot_traffic'
    };
  }

  if (phase4Experiment.enabled && phase4Experiment.variant === 'prompt_first') {
    return {
      allowed: false,
      reason: 'experiment_prompt_first'
    };
  }

  if (!isLocalHost && !highConfidenceCountries.includes(countryCode)) {
    return {
      allowed: false,
      reason: 'not_high_confidence_country'
    };
  }

  if (
    phase4Experiment.enabled &&
    phase4Experiment.variant === 'aggressive_auto' &&
    !isLocalHost
  ) {
    return {
      allowed: true,
      reason: 'experiment_aggressive_auto'
    };
  }

  if (getAutoRedirectedStore() === suggestedStore) {
    return {
      allowed: false,
      reason: 'session_already_redirected'
    };
  }

  return {
    allowed: true,
    reason: 'allowed'
  };
}

function trackGeoEvent(name, payload) {
  const eventPayload = {
    event: `afj_geo_${name}`,
    experimentEnabled: phase4Experiment.enabled,
    experimentVariant: phase4Experiment.variant,
    host: currentHost,
    ...payload
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventPayload);

  document.dispatchEvent(
    new CustomEvent(`afj:geo:${name}`, {
      detail: payload
    })
  );
}

function isBotTraffic() {
  const userAgent = (navigator.userAgent || '').toLowerCase();
  const botMarkers = ['bot', 'spider', 'crawl', 'slurp', 'bingpreview', 'facebookexternalhit'];

  return botMarkers.some(marker => userAgent.includes(marker));
}

function markAutoRedirectedStore(store) {
  try {
    window.sessionStorage.setItem(AUTO_REDIRECT_SESSION_KEY, store);
  } catch (error) {
    // Ignore storage failures (private mode, blocked storage, etc.)
  }
}

function getAutoRedirectedStore() {
  try {
    return window.sessionStorage.getItem(AUTO_REDIRECT_SESSION_KEY) || '';
  } catch (error) {
    return '';
  }
}

function getPromptDismissedSessionKey(activeStore, targetStore) {
  return `${PROMPT_DISMISSED_SESSION_KEY_PREFIX}_${activeStore}_${targetStore}`;
}

function markPromptDismissedThisSession(activeStore, targetStore) {
  try {
    window.sessionStorage.setItem(getPromptDismissedSessionKey(activeStore, targetStore), '1');
  } catch (error) {
    // Ignore storage failures.
  }
}

function hasDismissedPromptThisSession(activeStore, targetStore) {
  // Keep localhost and Theme Editor easy to QA without manually clearing session state.
  if (allowQaOverrides || isThemeEditor) {
    return false;
  }

  try {
    return (
      window.sessionStorage.getItem(getPromptDismissedSessionKey(activeStore, targetStore)) === '1'
    );
  } catch (error) {
    return false;
  }
}

async function getCountryCode() {
  const queryCountry = urlParams.get('geo_country');

  if (typeof queryCountry === 'string' && queryCountry.trim()) {
    return normalizeCountryCode(queryCountry);
  }

  const browseDetectedCountry = await detectCountryCodeFromBrowsingContext();

  if (browseDetectedCountry) {
    return browseDetectedCountry;
  }

  const detectedCountry =
    window.afjGeoRedirectConfig && window.afjGeoRedirectConfig.detectedCountryIsoCode;

  if (typeof detectedCountry === 'string' && detectedCountry.trim()) {
    return normalizeCountryCode(detectedCountry);
  }

  const shopifyCountry = window.Shopify && window.Shopify.country;

  if (typeof shopifyCountry === 'string' && shopifyCountry.trim()) {
    return normalizeCountryCode(shopifyCountry);
  }

  const configuredCountry =
    window.afjGeoRedirectConfig && window.afjGeoRedirectConfig.countryIsoCode;

  if (typeof configuredCountry === 'string' && configuredCountry.trim()) {
    return normalizeCountryCode(configuredCountry);
  }

  return '';
}

function resolveLocalHostCurrentStore() {
  const detectedCountry = normalizeCountryCode(
    (geoConfig && geoConfig.detectedCountryIsoCode) || ''
  );

  if (detectedCountry && countryToStoreMap[detectedCountry]) {
    return countryToStoreMap[detectedCountry];
  }

  const configuredCountry = normalizeCountryCode((geoConfig && geoConfig.countryIsoCode) || '');

  if (configuredCountry && countryToStoreMap[configuredCountry]) {
    return countryToStoreMap[configuredCountry];
  }

  return 'au';
}

function normalizeCountryCode(value) {
  const normalized = String(value || '').trim().toUpperCase();

  if (!normalized) {
    return '';
  }

  // Keep full tokens like EUROPE/ASIA for manual QA overrides, while
  // validating standard ISO codes for detected values.
  if (/^[A-Z]{2}$/.test(normalized) || /^[A-Z_]{3,20}$/.test(normalized)) {
    return normalized;
  }

  return '';
}

async function detectCountryCodeFromBrowsingContext() {
  if (detectedCountryCodePromise) {
    return detectedCountryCodePromise;
  }

  if (typeof window.fetch !== 'function' || typeof window.AbortController !== 'function') {
    return '';
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => {
    controller.abort();
  }, COUNTRY_DETECTION_TIMEOUT_MS);

  detectedCountryCodePromise = window
    .fetch(BROWSING_CONTEXT_SUGGESTIONS_PATH, {
      method: 'GET',
      credentials: 'same-origin',
      signal: controller.signal,
      headers: {
        Accept: 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        return null;
      }

      return response.json();
    })
    .then(payload => {
      const detectedHandle =
        payload &&
        payload.detected_values &&
        payload.detected_values.country &&
        payload.detected_values.country.handle;

      return normalizeCountryCode(detectedHandle);
    })
    .catch(() => '')
    .finally(() => {
      window.clearTimeout(timeoutId);
    });

  return detectedCountryCodePromise;
}

function isExcludedPath(pathname) {
  if (EXCLUDED_EXACT_PATHS.includes(pathname)) {
    return true;
  }

  return EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

function stripSwitchParamFromUrl() {
  const currentUrl = new URL(window.location.href);

  if (!currentUrl.searchParams.has(SWITCH_PARAM)) {
    return;
  }

  currentUrl.searchParams.delete(SWITCH_PARAM);
  const updated = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
  window.history.replaceState({}, document.title, updated);
}

function setCookie(name, value, maxAgeSeconds) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

function getCookie(name) {
  const cookies = document.cookie ? document.cookie.split('; ') : [];

  for (let i = 0; i < cookies.length; i += 1) {
    const [key, ...rest] = cookies[i].split('=');

    if (key === name) {
      return decodeURIComponent(rest.join('='));
    }
  }

  return '';
}

function buildTargetUrl(targetHost) {
  const targetUrl = new URL(window.location.href);
  targetUrl.hostname = targetHost;
  targetUrl.port = '';
  targetUrl.searchParams.set(SWITCH_PARAM, '1');
  return targetUrl.toString();
}

function resolvePopupSettings() {
  const configured = geoConfig.popup && typeof geoConfig.popup === 'object' ? geoConfig.popup : {};
  const normalizedPosition = String(configured.position || 'center').trim().toLowerCase();

  return {
    enabled: configured.enabled !== false,
    position: ['center', 'bottom-right', 'bottom-left'].includes(normalizedPosition)
      ? normalizedPosition
      : 'center',
    overlayColor: String(configured.overlayColor || 'rgba(0,0,0,0.5)'),
    overlayOpacity: normalizePercentage(configured.overlayOpacity, 50),
    autoRedirectAfterCountdown: Boolean(configured.autoRedirectAfterCountdown),
    countdownSeconds: normalizeInteger(configured.countdownSeconds, 8, 3, 30),
    heading: String(configured.heading || '').trim(),
    body: String(configured.body || '').trim(),
    overrideTextColors: Boolean(configured.overrideTextColors),
    headingColor: String(configured.headingColor || '#111111'),
    bodyColor: String(configured.bodyColor || '#4b4b4b'),
    headingFontFamily: resolveFontFamilyChoice(configured.headingFontFamily, 'heading'),
    bodyFontFamily: resolveFontFamilyChoice(configured.bodyFontFamily, 'body'),
    buttonFontFamily: resolveFontFamilyChoice(configured.buttonFontFamily, 'body'),
    headingFontSize: normalizeNumber(configured.headingFontSize, 15),
    bodyFontSize: normalizeNumber(configured.bodyFontSize, 14),
    buttonFontSize: normalizeNumber(configured.buttonFontSize, 13),
    imageSide: resolveImageSideChoice(configured.imageSide, 'left'),
    imageUrl: typeof configured.imageUrl === 'string' ? configured.imageUrl.trim() : '',
    overrideImageTint: Boolean(configured.overrideImageTint),
    imageTintColor: String(configured.imageTintColor || 'rgba(0,0,0,0)'),
    imageTintOpacity: normalizePercentage(configured.imageTintOpacity, 0),
    primaryButtonText: String(configured.primaryButtonText || '').trim(),
    secondaryButtonText: String(configured.secondaryButtonText || '').trim(),
    buttonLayout: resolveButtonLayoutChoice(configured.buttonLayout, 'inline'),
    overrideButtonColors: Boolean(configured.overrideButtonColors),
    buttonBackground: String(configured.buttonBackground || '#111111'),
    buttonText: String(configured.buttonText || '#ffffff'),
    buttonBorder: String(configured.buttonBorder || '#111111')
  };
}

function normalizePercentage(value, fallback) {
  const parsed = Number(value);

  if (Number.isNaN(parsed)) {
    return fallback;
  }

  return Math.min(100, Math.max(0, parsed));
}

function normalizeNumber(value, fallback) {
  const parsed = Number(value);

  if (Number.isNaN(parsed)) {
    return fallback;
  }

  return parsed;
}

function normalizeInteger(value, fallback, min, max) {
  const parsed = Number(value);

  if (Number.isNaN(parsed)) {
    return fallback;
  }

  const rounded = Math.round(parsed);
  return Math.min(max, Math.max(min, rounded));
}

function resolveFontFamilyChoice(value, fallback) {
  const normalized = String(value || fallback).trim().toLowerCase();

  if (normalized === 'heading' || normalized === 'body') {
    return normalized;
  }

  return fallback;
}

function resolveImageSideChoice(value, fallback) {
  const normalized = String(value || fallback).trim().toLowerCase();

  if (normalized === 'left' || normalized === 'right') {
    return normalized;
  }

  return fallback;
}

function resolveButtonLayoutChoice(value, fallback) {
  const normalized = String(value || fallback).trim().toLowerCase();

  if (normalized === 'inline' || normalized === 'full') {
    return normalized;
  }

  return fallback;
}

function resolveColumnWidths() {
  // Fixed split for the 600x540 popup layout.
  // Image is on the right by default.
  return {
    image: 50,
    content: 50
  };
}
function resolvePopupFrameStyles(hasImage) {
  return {
    width: '600px',
    minHeight: '540px',
    mobileImageMinHeight: 180
  };
}

function resolveConfiguredCopy(defaultCopy, interpolationValues) {
  const customTitle = interpolateCopyVariables(popupSettings.heading, interpolationValues);
  const customBody = interpolateCopyVariables(popupSettings.body, interpolationValues);
  const customPrimary = interpolateCopyVariables(
    popupSettings.primaryButtonText,
    interpolationValues
  );
  const customSecondary = interpolateCopyVariables(
    popupSettings.secondaryButtonText,
    interpolationValues
  );

  return {
    title: customTitle || defaultCopy.title,
    text: customBody || defaultCopy.text,
    switchLabel: customPrimary || defaultCopy.switchLabel,
    stayLabel: customSecondary || defaultCopy.stayLabel
  };
}

function interpolateCopyVariables(value, interpolationValues) {
  if (!value) {
    return '';
  }

  return Object.keys(interpolationValues).reduce((resolvedValue, token) => {
    const replacement = String(interpolationValues[token] || '');
    return resolvedValue.replace(new RegExp(`\\{${token}\\}`, 'gi'), replacement);
  }, value);
}

function resolveCountryDisplayName(countryCode) {
  if (!countryCode) {
    return '';
  }

  if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') {
    return countryCode;
  }

  try {
    const displayNames = new Intl.DisplayNames(['en'], {
      type: 'region'
    });

    return displayNames.of(countryCode) || countryCode;
  } catch (error) {
    return countryCode;
  }
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function renderPrompt({
  currentStore: activeStore,
  suggestedStore: targetStore,
  countryCode,
  isPreviewMode = false
}) {
  const targetHost = HOST_BY_STORE[targetStore];
  const targetLabel = STORE_LABEL[targetStore];
  const normalizedCountryCode = String(countryCode || '').trim().toUpperCase();
  const countryName = resolveCountryDisplayName(normalizedCountryCode);
  const promptCopy = resolveConfiguredCopy(resolvePromptCopy(targetLabel), {
    store: targetLabel,
    country: countryName || normalizedCountryCode || 'your region',
    country_name: countryName || normalizedCountryCode || 'your region',
    country_code: normalizedCountryCode
  });

  if (!targetHost || !targetLabel) {
    return;
  }

  const positionClass = `afj-geo-prompt--${popupSettings.position}`;
  const shouldShowImage = Boolean(popupSettings.imageUrl);
  const headingFontStack =
    popupSettings.headingFontFamily === 'heading' ? 'var(--heading-font-stack)' : 'var(--body-font-stack)';
  const bodyFontStack =
    popupSettings.bodyFontFamily === 'heading' ? 'var(--heading-font-stack)' : 'var(--body-font-stack)';
  const buttonFontStack =
    popupSettings.buttonFontFamily === 'heading' ? 'var(--heading-font-stack)' : 'var(--body-font-stack)';
  const shouldAutoRedirectAfterCountdown =
    popupSettings.autoRedirectAfterCountdown && popupSettings.countdownSeconds > 0 && !isPreviewMode;
  const isImageRight = popupSettings.imageSide === 'right';
  const buttonLayoutClass = popupSettings.buttonLayout === 'full' ? 'afj-geo-prompt__actions--full' : '';
  const columnWidths = resolveColumnWidths();
  const effectiveColumnWidths = shouldShowImage
    ? columnWidths
    : {
      image: 0,
      content: 100
    };
  const popupFrameStyles = resolvePopupFrameStyles(shouldShowImage);

  const overlay = document.createElement('div');
  overlay.className = 'afj-geo-prompt-overlay';
  overlay.style.cssText = `background:${popupSettings.overlayColor};opacity:${popupSettings.overlayOpacity / 100}`;

  const wrapper = document.createElement('aside');
  const wrapperClass = isImageRight ? `afj-geo-prompt ${positionClass} afj-geo-prompt--image-right` : `afj-geo-prompt ${positionClass}`;
  wrapper.className = wrapperClass;
  wrapper.setAttribute('role', 'dialog');
  wrapper.setAttribute('aria-live', 'polite');
  wrapper.setAttribute('aria-label', 'Store switch suggestion');
  
  const cssVars = `
    --afj-popup-width:${popupFrameStyles.width};
    --afj-popup-height:${popupFrameStyles.minHeight};
    --afj-popup-font-family:${bodyFontStack};
    --afj-heading-font-family:${headingFontStack};
    --afj-button-font-family:${buttonFontStack};
    --afj-heading-size:${popupSettings.headingFontSize}px;
    --afj-body-size:${popupSettings.bodyFontSize}px;
    --afj-button-size:${popupSettings.buttonFontSize}px;
    --afj-heading-color:${popupSettings.overrideTextColors ? popupSettings.headingColor : '#111111'};
    --afj-body-color:${popupSettings.overrideTextColors ? popupSettings.bodyColor : '#4b4b4b'};
    --afj-button-primary-background:${popupSettings.overrideButtonColors ? popupSettings.buttonBackground : '#111'};
    --afj-button-primary-text:${popupSettings.overrideButtonColors ? popupSettings.buttonText : '#fff'};
    --afj-button-primary-border:${popupSettings.overrideButtonColors ? popupSettings.buttonBorder : '#111'};
    --afj-image-width:${effectiveColumnWidths.image}%;
    --afj-content-width:${effectiveColumnWidths.content}%;
    --afj-mobile-image-min-height:${popupFrameStyles.mobileImageMinHeight}px;
    --afj-image-tint-color:${popupSettings.overrideImageTint ? popupSettings.imageTintColor : 'rgba(0,0,0,0)'};
    --afj-image-tint-opacity:${popupSettings.overrideImageTint ? popupSettings.imageTintOpacity / 100 : '0'}
  `;
  wrapper.style.cssText = cssVars;

  wrapper.innerHTML = `
    <button type="button" class="afj-geo-prompt__close" aria-label="Close" data-action="close"><span class="afj-geo-prompt__close-icon" aria-hidden="true"></span></button>
    ${shouldShowImage ? '<div class="afj-geo-prompt__image"></div>' : ''}
    <div class="afj-geo-prompt__content">
      <div class="afj-geo-prompt__main">
        <p class="afj-geo-prompt__title">${escapeHtml(promptCopy.title)}</p>
        <p class="afj-geo-prompt__text">${escapeHtml(promptCopy.text)}</p>
        <div class="afj-geo-prompt__actions ${buttonLayoutClass}">
          <button type="button" class="afj-geo-prompt__btn afj-geo-prompt__btn--primary" data-action="switch">${escapeHtml(promptCopy.switchLabel)}</button>
          <button type="button" class="afj-geo-prompt__btn" data-action="stay">${escapeHtml(promptCopy.stayLabel)}</button>
        </div>
      </div>
      ${shouldAutoRedirectAfterCountdown ? '<div class="afj-geo-prompt__auto-redirect"><p class="afj-geo-prompt__countdown" data-countdown></p><div class="afj-geo-prompt__countdown-bar" aria-hidden="true"><div class="afj-geo-prompt__countdown-bar-fill" data-countdown-bar-fill></div></div></div>' : ''}
    </div>
  `;

  const imageElement = wrapper.querySelector('.afj-geo-prompt__image');
  if (imageElement && popupSettings.imageUrl) {
    imageElement.style.backgroundImage = `url("${popupSettings.imageUrl.replace(/"/g, '\\"')}")`;
  }

  const countdownElement = wrapper.querySelector('[data-countdown]');
  const countdownBarFillElement = wrapper.querySelector('[data-countdown-bar-fill]');
  let countdownIntervalId;
  let modalConflictIntervalId;
  let remainingSeconds = popupSettings.countdownSeconds;

  const closePrompt = () => {
    if (countdownIntervalId) {
      clearInterval(countdownIntervalId);
      countdownIntervalId = null;
    }

    if (modalConflictIntervalId) {
      clearInterval(modalConflictIntervalId);
      modalConflictIntervalId = null;
    }

    wrapper.remove();
    overlay.remove();
  };

  const redirectToSuggestedStore = source => {
    if (isPreviewMode) {
      trackGeoEvent('prompt_redirect_blocked_theme_editor', {
        fromStore: activeStore,
        toStore: targetStore,
        countryCode,
        source
      });
      closePrompt();
      return;
    }

    setCookie(COOKIE_NAME, targetStore, COOKIE_MAX_AGE_SECONDS);
    markPromptDismissedThisSession(activeStore, targetStore);
    markAutoRedirectedStore(targetStore);
    trackGeoEvent(source, {
      fromStore: activeStore,
      toStore: targetStore,
      countryCode,
      countdownSeconds: popupSettings.countdownSeconds
    });
    window.location.assign(buildTargetUrl(targetHost));
  };

  modalConflictIntervalId = setInterval(() => {
    if (!document.body.contains(wrapper)) {
      clearInterval(modalConflictIntervalId);
      modalConflictIntervalId = null;
      return;
    }

    if (hasBlockingThemePopup()) {
      trackGeoEvent('prompt_hidden_for_modal_conflict', {
        fromStore: activeStore,
        toStore: targetStore,
        countryCode
      });
      closePrompt();
    }
  }, 300);

  if (shouldAutoRedirectAfterCountdown && countdownElement) {
    const updateCountdownLabel = () => {
      countdownElement.textContent = `Auto redirecting in ${remainingSeconds}s.`;
    };

    const updateCountdownProgress = () => {
      if (!countdownBarFillElement) {
        return;
      }

      const ratio = Math.max(0, Math.min(1, remainingSeconds / popupSettings.countdownSeconds));
      countdownBarFillElement.style.width = `${ratio * 100}%`;
    };

    updateCountdownLabel();
    updateCountdownProgress();

    trackGeoEvent('prompt_countdown_started', {
      fromStore: activeStore,
      toStore: targetStore,
      countryCode,
      countdownSeconds: popupSettings.countdownSeconds
    });

    countdownIntervalId = setInterval(() => {
      remainingSeconds -= 1;

      if (remainingSeconds <= 0) {
        if (countdownIntervalId) {
          clearInterval(countdownIntervalId);
          countdownIntervalId = null;
        }
        updateCountdownProgress();
        redirectToSuggestedStore('prompt_countdown_auto_redirect');
        return;
      }

      updateCountdownLabel();
      updateCountdownProgress();
    }, 1000);
  }

  trackGeoEvent('prompt_shown', {
    fromStore: activeStore,
    toStore: targetStore,
    countryCode,
    previewMode: isPreviewMode
  });

  wrapper.addEventListener('click', event => {
    const button = event.target.closest('button[data-action]');

    if (!button) {
      return;
    }

    const action = button.getAttribute('data-action');

    if (action === 'stay' || action === 'close') {
      setCookie(COOKIE_NAME, activeStore, COOKIE_MAX_AGE_SECONDS);
      markPromptDismissedThisSession(activeStore, targetStore);
      trackGeoEvent(action === 'close' ? 'prompt_closed' : 'prompt_stay', {
        currentStore: activeStore,
        suggestedStore: targetStore,
        countryCode
      });
      closePrompt();
      return;
    }

    if (action === 'switch') {
      redirectToSuggestedStore('prompt_switch');
    }
  });

  document.body.appendChild(overlay);
  document.body.appendChild(wrapper);
}

function resolvePromptCopy(targetLabel) {
  if (phase4Experiment.enabled && phase4Experiment.variant === 'prompt_first') {
    return {
      title: 'Choose your preferred store',
      text: `You are viewing a shared page. Switch to our ${targetLabel} store for local pricing and checkout.`,
      switchLabel: `Switch to ${targetLabel}`,
      stayLabel: 'Keep current store'
    };
  }

  if (phase4Experiment.enabled && phase4Experiment.variant === 'aggressive_auto') {
    return {
      title: 'We found your best store match',
      text: `Continue to our ${targetLabel} store and stay on this same page.`,
      switchLabel: `Continue to ${targetLabel}`,
      stayLabel: 'Stay on this store'
    };
  }

  return {
    title: 'Shopping from the wrong store?',
    text: `We can take you to our ${targetLabel} store and keep you on the same page.`,
    switchLabel: `Go to ${targetLabel} store`,
    stayLabel: 'Stay here'
  };
}
